import { render } from "./UserAdd.vue?vue&type=template&id=1fd58a96&scoped=true"
import script from "./UserAdd.vue?vue&type=script&lang=js"
export * from "./UserAdd.vue?vue&type=script&lang=js"

import "./UserAdd.vue?vue&type=style&index=0&id=1fd58a96&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd58a96"]])

export default __exports__